import { API, ENDPOINTS } from '@/app/services/api-url';

export default {
  name: 'share-item',
  props: {
    uuid: {
      type: String,
      required: true,
    },
    email: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    loading: false,
  }),
  methods: {
    handleRevoke() {
      this.loading = true;
      const accountId = this.$store.getters['account/getActiveAccount'].uuid;

      return API.delete(`${ENDPOINTS.DELETE_SHARE}/${this.uuid}?accountID=${accountId}`)
        .then((res) => {
          if (res.status === 202) {
            this.$emit('delete');
          }
          this.loading = false;
          return res;
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
